module.exports = __webpack_public_path__ + "img/13.16edb393.svg";